import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Battery_card_listing = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage] = useState(10);
      const [searchTerm, setSearchTerm] = useState("");

      const canView  = hasPermission("Battery Card Maintenance", "view");
          const canEntry = hasPermission("Battery Card Maintenance", "entry");
          const canEdit  = hasPermission("Battery Card Maintenance", "edit");
          const canDel   = hasPermission("Battery Card Maintenance", "del");
        

  // Fetch branches only once
  useEffect(() => {
  const fetchBatteryBranches = async () => {
    let progress = 0;

    const updateProgress = (val) => {
      const bar = document.getElementById("progress-bar");
      const text = document.getElementById("progress-text");
      if (bar) bar.style.width = `${val}%`;
      if (text) text.innerText = `Loading... ${val}%`;
    };

    Swal.fire({
      title: "Loading Battery Codes",
      html: `
        <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
        </div>
        <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => updateProgress(0),
    });

    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/battery_listing");
      setBranches(response.data.branches || []);
      updateProgress(100);
      setTimeout(() => Swal.close(), 400);
    } catch (error) {
      console.error("Error fetching Codes:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load battery Codes.",
      });
    }
  };
{canView && (
  fetchBatteryBranches()
)}
}, []);

  // Fetch ALL records initially
  useEffect(() => {
    setLoading(true);
    axios.get("https://rfs2.infraconsoft.net.in/api/battery_listing")
      .then((response) => {
        setData(response.data.vehicles);
        setFilteredData(response.data.vehicles);
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Fetch filtered data when branch is selected
  useEffect(() => {
    if (selectedBranch) {
      setLoading(true);
      axios.get("https://rfs2.infraconsoft.net.in/api/battery_listing", {
        params: { battery_code: selectedBranch }
      })
      .then((response) => {
        setData(response.data.vehicles);
        setFilteredData(response.data.vehicles);
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
      })
      .finally(() => {
        setLoading(false);
      });
    }
  }, [selectedBranch]); 

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.vehicle && item.vehicle.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.battery_code && item.battery_code.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.battery_type && item.battery_type.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); 
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`https://rfs2.infraconsoft.net.in/api/battery_delete/${id}`);
          setData(data.filter((item) => item.No !== id));
          setFilteredData(filteredData.filter((item) => item.No !== id));

          Swal.fire({
            title: "Deleted!",
            text: "Your record has been deleted.",
            icon: "success"
          });
        } catch (error) {
          console.error("Error deleting vehicle position:", error);
          Swal.fire({
            title: "Error!",
            text: "Failed to delete vehicle position.",
            icon: "error"
          });
        }
      }
    });
  };

if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Battery Card View</h2>
          <Time />
        </section>

{canEntry && (
        <div className="add-new-container">
            <Link to={`/battery_transaction_entry`}><button className="add-new-btn"><i className="fa-solid fa-plus"></i> Add New</button></Link>
        </div>
)}

            <div className="vehicle-class">
  <div>
    <p>Select your Battery Code :</p>
<select value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)} className="branch-select">
            <option value="">-- Battery Code --</option>
            {branches.map((item) => (
              <option key={item.battery_code} value={item.battery_code}>
                {item.battery_code}
              </option>
            ))}
          </select>
  </div>
  </div>

  
        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by vehicleName" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle</th>
                <th>Battery Code</th>
                <th>Battery Type</th>
                <th>Fitted Date</th>
                <th>Report View</th>
                {canEdit && (
                <th>Edit</th>
                )}
                {canDel && (
                <th>Delete</th>
                )}
              </tr>
            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="6" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem + index + 1}</td>
        <td>{item.vehicle}</td>
        <td>{item.battery_code}</td>
        <td>{item.battery_type}</td>
        <td>{item.fitted_date ? new Date(item.fitted_date).toLocaleDateString('en-GB') : ''}</td>
<td>
  {item.has_report ? (
    <Link
      to={`/battery_report_view/${item.No}`}
      style={{ color: "#b736fe", fontWeight: "bold" }}
    >
      View
    </Link>
  ) : (
    canEntry && (
      <Link
        to={`/battery_report_entry/${item.No}`}
        style={{ color: "red", fontWeight: "bold" }}
      >
        Report
      </Link>
    )
  )}
</td>


        {canEdit && (
        <td><Link to={`/battery_transaction_edit/${item.No}`}><i className="fa-solid fa-pen-to-square edit"></i></Link></td>
        )}

{canDel && (
        <td className="del">
          <i className="fa-solid fa-trash-can" onClick={() => handleDelete(item.No)}></i>
        </td>
)}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>

        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>1</button>
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}> Next</button>
        </div>
      </div>
    </div>
  );
};

export default Battery_card_listing;
